/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Subscription_UpdatedInputs */

const en_plan_subscription_updated = /** @type {(inputs: Plan_Subscription_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription updated successfully`)
};

const es_plan_subscription_updated = /** @type {(inputs: Plan_Subscription_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción actualizada exitosamente`)
};

/**
* | output |
* | --- |
* | "Subscription updated successfully" |
*
* @param {Plan_Subscription_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_subscription_updated = /** @type {((inputs?: Plan_Subscription_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Subscription_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_subscription_updated(inputs)
	return en_plan_subscription_updated(inputs)
});